import { Card } from "components/styles";
import styled from "styled-components";

export const LoginLayoutBox = styled(Card)`
  padding: 0.5rem 1.5rem 0.5rem;
`;

export const Logo = styled.img`
  height: 10rem;
`;
